import Vue from 'vue';
import 'babel-polyfill';
import Es6Promise from 'es6-promise';
Es6Promise.polyfill();
import App from './App.vue';
import axios from 'axios';
import '@/plugins/vuetify';
import '@/plugins/gtm';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; 
import JsonExcel from 'vue-json-excel';

Vue.component('downloadExcel', JsonExcel);

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

new Vue({
  render: h => h(App)
}).$mount('#app');
